<!-- 2025女神节活动 -->
<template>
  <div class="goddess-festival-index">
    <div class="music-box">
      <!-- 背景音乐 autoplay-->
      <audio id="bgMusic" loop volume="0.2">
        <source
          src="@/assets/imgs/activityCenter/goddessFestival/music.mp3"
          type="audio/mpeg"
        />
        您的浏览器不支持 audio 元素。
      </audio>
    </div>
    <!-- 图片加载等待页面 -->
    <div class="loading-page" v-if="pageLoading">
      <img
        :src="require(`@/assets/imgs/activityCenter/goddessFestival/fl.png`)"
        class="loading-icon"
        alt=""
      />
    </div>
    <!-- 封面 -->
    <div class="cover" v-if="[0, 1].includes(process)">
      <Cover
        :imgUrlMap="imgUrlMap"
        :userInfo="userInfo"
        :process="process"
        @setProcess="setProcess"
        @setUserInfo="setUserInfo"
        @openMusic="openMusic"
        ref="coverRef"
      />
    </div>
    <!-- 内容页面 -->
    <div class="content">
      <Greet
        :imgUrlMap="imgUrlMap"
        :userInfo="userInfo"
        :process="process"
        @setProcess="setProcess"
        @receive="receive"
        ref="greetRef"
      />
    </div>
    <ResultPopup
      :userInfo="userInfo"
      :imgUrlMap="imgUrlMap"
      ref="resultPopupRef"
    />
  </div>
</template>
<script setup>

import { reactive, ref, computed, onBeforeMount, onMounted, defineExpose, defineEmits, nextTick } from 'vue'
import { useRoute, useRouter, } from "vue-router";
import { Toast } from 'vant';
import { isSupportWebP } from '@/utils/common'
import Cover from './components/cover'
import Greet from './components/greet'
import ResultPopup from './components/resultPopup'
import { getCookie } from '@/utils/cookie'

const route = useRoute();
const router = useRouter();

const coverRef = ref(null)
const greetRef = ref(null)
const resultPopupRef = ref(null)
const pageLoading = ref(true)
const imgUrlMap = ref({}) // 图片地址
const userInfo = ref({
  name: '小仙女',
  blessing: '公司送你三朵花：\n有钱花，\n随便花，\n貌美如花。',
  status: 0,
  gender: 0, // 角色：0、女；1、男
  companyMain: 0, // 公司主体 0电商 1数科
}) // 用户信息

const process = ref(0) // 过程 0、填写账号；1、封面；2：内容

onBeforeMount(() => {
  setImgType()
  getCacheInfo()
})

onMounted(() => {
  openMusic() // 音乐
});
// 获取缓存信息
const getCacheInfo = () => {
  let token = getCookie('womensDayToken')
  let _cacheInfo = getCookie('womensDayInfo')
  // console.log(_cacheInfo);
  if (token) {
    _cacheInfo = JSON.parse(_cacheInfo)
    // _cacheInfo.blessing = '希望你能成为一个有趣和有钱的人，实在不行光有钱也可以。'

    userInfo.value = _cacheInfo
    setProcess(1)
  }
}
// 设置用户信息
const setUserInfo = (value) => {
  userInfo.value = value
  setProcess(1)
}

// 修改步骤
const setProcess = (val) => {
  process.value = val
  nextTick(() => {
    if (val === 1) {
      // 登录成功
      coverRef.value.beginAnimation() // 封面动画开始
      openMusic() // 音乐
    }
    if (val === 2) {
      // 开启信封
      greetRef.value.beginAnimation()
      // openMusic() // 音乐
    }
  })
}
// 设置图片集合
const setImgType = () => {
  isSupportWebP().then((pass) => {
    if (pass) {
      // console.log('支持webp');
      setImgUrlMap('webp')
    } else {
      console.log('不支持webp');
      setImgUrlMap('png')
    }


  }).catch(() => {
    console.log('不支持webp');
    setImgUrlMap('png')
  })
}
// 领取
const receive = () => {
  resultPopupRef.value.handleOpen()
}
const openMusic = () => {
  const bgMusic = document.getElementById('bgMusic');
  if (bgMusic !== null) {
    // 添加播放许可
    if (bgMusic.paused) { // 暂停
      bgMusic.muted = true; // 先静音播放
      bgMusic.play().then(() => {
        bgMusic.muted = false; // 播放成功后再取消静音
      })
    } else {
      bgMusic.play();
    }

    // console.log('播放状态', bgMusic.paused);
  }
}
const closeMusic = () => {
  const bgMusic = document.getElementById('bgMusic');
  const audio = document.getElementById('diceMusic');
  if (bgMusic !== null) {
    if (!bgMusic.paused) {
      bgMusic.pause();
    }
  }
  if (audio !== null) {
    if (!audio.paused) {
      audio.pause();
    }
  }
}
// 设置图片集合
const setImgUrlMap = (suffix) => {
  let imgList = {
    // 固定后缀
    boy: require('@/assets/imgs/activityCenter/goddessFestival/boy.png'),
    girl: require('@/assets/imgs/activityCenter/goddessFestival/girl.png'),
    day: require('@/assets/imgs/activityCenter/goddessFestival/day.png'),
    start1: require('@/assets/imgs/activityCenter/goddessFestival/start1.png'),
    logo: require('@/assets/imgs/activityCenter/goddessFestival/logo.png'),
    topHappy: require('@/assets/imgs/activityCenter/goddessFestival/topHappy.png'),
    top37: require('@/assets/imgs/activityCenter/goddessFestival/top37.png'),
    greet: require('@/assets/imgs/activityCenter/goddessFestival/greet.png'),
    input1: require('@/assets/imgs/activityCenter/goddessFestival/input1.png'),
    input2: require('@/assets/imgs/activityCenter/goddessFestival/input2.png'),

    // 动态后缀
    login1: require(`@/assets/imgs/activityCenter/goddessFestival/login1.${suffix}`),
    login2: require(`@/assets/imgs/activityCenter/goddessFestival/login2.${suffix}`),
    login3: require(`@/assets/imgs/activityCenter/goddessFestival/login3.${suffix}`),
    pic1: require(`@/assets/imgs/activityCenter/goddessFestival/pic1.${suffix}`),
    pic2: require(`@/assets/imgs/activityCenter/goddessFestival/pic2.${suffix}`),
    flower: require(`@/assets/imgs/activityCenter/goddessFestival/flower.${suffix}`),
  }
  imgUrlMap.value = imgList
  preloadImg(imgList)

  // console.log(imgUrlMap.value);

}

// 图片预加载
const preloadImg = (imgList) => {
  // console.log(imgList, '图片预加载=');
  let sum = Object.keys(imgList).length
  let num = 0
  for (const key in imgList) {
    if (Object.hasOwnProperty.call(imgList, key)) {
      const element = imgList[key];
      const img = new Image();
      img.src = element;
      img.onload = () => {
        // 图片加载完整
        num++
        if (sum === num) {
          console.log('图片加载完成');
          pageLoading.value = false
        }
      }
    }
  }
}

</script>
<style  lang="less" scoped>
@keyframes flowerSwing {
  0% {
    transform: rotate(-20deg);
  }
  100% {
    transform: rotate(20deg);
  }
}
.goddess-festival-index {
  position: relative;
  width: 100%;
  height: 100vh;
  .loading-page {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    .loading-icon {
      margin-bottom: 90px;
      width: 50px;
      transform-origin: 50% 100%;
      animation: flowerSwing 0.6s ease-in-out infinite alternate;
    }
  }
  .cover {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .content {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
